import { useState, useEffect } from 'react'
import { useApp } from '../context/AppContext'
import { useTheme } from '../hooks/useTheme'

const CONSENT_KEY = 'privacy_consent'

export default function PrivacyConsentModal() {
  const [visible, setVisible] = useState(false)
  const { navigate } = useApp()
  const { bgPrimary, textPrimary, textSecondary, isDark } = useTheme()

  useEffect(() => {
    const consented = localStorage.getItem(CONSENT_KEY)
    if (!consented) {
      setVisible(true)
    }
  }, [])

  const handleAgree = () => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      agreed: true,
      time: new Date().toISOString()
    }))
    setVisible(false)
  }

  const handleDisagree = () => {
    // 不同意则退出应用
    if (window.Capacitor) {
      window.Capacitor.Plugins.App.exitApp?.()
    } else {
      alert('如需使用本应用，请同意隐私政策。')
    }
  }

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      zIndex: 10000, display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center',
      background: isDark ? 'rgba(0,0,0,0.85)' : 'rgba(0,0,0,0.5)',
      padding: '24px'
    }}>
      <div style={{
        maxWidth: '360px', width: '100%',
        background: bgPrimary,
        borderRadius: '16px', padding: '24px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
      }}>
        <h2 style={{ color: textPrimary, fontSize: '18px', fontWeight: 700, marginBottom: '16px', textAlign: 'center' }}>
          欢迎使用说灵灵
        </h2>

        <div style={{ color: textSecondary, fontSize: '13px', lineHeight: 1.8, marginBottom: '16px' }}>
          <p className="mb-3">感谢您选择说灵灵！我们非常重视您的个人信息和隐私保护。在您使用本应用前，请仔细阅读并充分理解以下内容：</p>
          <p className="mb-3">我们仅会收集为您提供服务所必需的个人信息，包括：手机号、学习记录、设备基本信息等。我们采取严格的安全措施保护您的数据，不会向第三方出售您的个人信息。</p>
          <p className="mb-3">您有权随时查看、更正、删除您的个人信息，或注销您的账户。</p>
          <p>
            具体内容详见
            <button
              onClick={() => navigate('privacy')}
              style={{ color: '#6C63FF', background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: '13px' }}
            >《隐私政策》</button>
            和
            <button
              onClick={() => navigate('terms')}
              style={{ color: '#6C63FF', background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: '13px' }}
            >《用户协议》</button>
          </p>
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={handleDisagree}
            style={{
              flex: 1, height: '44px', borderRadius: '12px',
              border: '1px solid #e0e0e0', background: 'transparent',
              color: textSecondary, fontSize: '15px', cursor: 'pointer'
            }}
          >不同意</button>
          <button
            onClick={handleAgree}
            style={{
              flex: 2, height: '44px', borderRadius: '12px',
              border: 'none', background: 'linear-gradient(135deg, #6C63FF, #8B5CF6)',
              color: '#fff', fontSize: '15px', fontWeight: 600, cursor: 'pointer'
            }}
          >同意并继续</button>
        </div>
      </div>
    </div>
  )
}
